// TODO: currency should be localized
export const formatCurrency = (amount: string | number) => {
  return (
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(typeof amount === "string" ? parseFloat(amount) : amount) || ""
  );
};
